import {
  IPublicClientApplication,
  PublicClientApplication,
  InteractionType,
  BrowserCacheLocation,
  LogLevel,
} from "@azure/msal-browser";
import {
  MsalInterceptorConfiguration,
  MsalGuardConfiguration,
} from "@azure/msal-angular";
import { CommonService } from "./shared/services/common.service";
import { environment } from "../environments/environment";

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

export function msalInstanceFactory(): IPublicClientApplication {
  const env: any = environment.tenant_info;
  const userDomain = window.location.host?.split(".")?.[0];
  const tenant = userDomain?.includes("localhost") ? "alpha" : userDomain;

  return new PublicClientApplication({
    auth: {
      clientId: env[tenant]?.CLIENT_ID,
      authority: "https://login.microsoftonline.com/" + env[tenant]?.TENANT_ID,
      redirectUri: "/auth/sso",
      postLogoutRedirectUri: "/",
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE,
    },
    system: {
      loggerOptions: {
        loggerCallback: (level: LogLevel, message: string) =>
          console.log(message),
        logLevel: LogLevel.Info,
        piiLoggingEnabled: false,
      },
    },
  });
}

export function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const map = new Map<string, Array<string>>();
  map.set("https://graph.microsoft.com/v1.0/me", ["user.read"]);
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: map,
  };
}

export function msalGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: { scopes: ["user.read"], prompt: "select_account" },
    loginFailedRoute: "/",
  };
}

export function initializeApp(commonService: CommonService) {
  return (): Promise<any> =>
    commonService
      .getDisplayNames()
      .toPromise()
      .then(
        (res: any) =>
          localStorage.setItem("displayLabels", JSON.stringify(res)),
        (err: any) => console.error(err)
      );
}
